// extracted by mini-css-extract-plugin
export default {"root":"DashboardNav_root__WXbC4","tabContent":"DashboardNav_tabContent__i6xVp","selectedTabContent":"DashboardNav_selectedTabContent__JyZDa"};